{
  "min": 114,
  "max": 246,
  "R": [0, 255, 255],
  "G": [0, 128, 255],
  "B": [0, 128, 255],
  "A": [0, 64, 96],
  "I": [0, 87, 255]
}
